export default "__VITE_ASSET__961179ed__"